// สวิตช์ "แสดงใน My Job" — enable = เพิ่มแถวใน brands, disable = ลบแถวนั้น
import { useMutation } from "@tanstack/react-query";
import { cn } from "@shared/lib/utils";
import { disableBrand, enableBrand } from "../api/settings-api";
import { useInvalidateSettings } from "../api/use-settings";

export function MyJobSwitch({
  enabled,
  payload,
}: {
  enabled: boolean;
  /** ค่าที่จะใช้สร้างแถวใน My Job ตอนเปิดสวิตช์ */
  payload: Parameters<typeof enableBrand>[0];
}) {
  const invalidate = useInvalidateSettings();
  const toggle = useMutation({
    mutationFn: async () => {
      if (enabled) await disableBrand(payload.id);
      else await enableBrand(payload);
    },
    // สำเร็จหรือไม่ก็ดึงค่าจริงมาใหม่ ไม่เดาสถานะเอง (409 = มีอยู่แล้วก็ถือว่าเปิดอยู่)
    onSettled: invalidate,
  });

  return (
    <div className="cfg-hero-toggle">
      <span className={cn("switch-lbl", enabled && "on")}>
        {enabled ? "แสดงใน My Job" : "ไม่แสดงใน My Job"}
      </span>
      <button
        type="button"
        className={cn("switch", enabled && "on")}
        role="switch"
        aria-checked={enabled}
        aria-label="แสดงใน My Job"
        disabled={toggle.isPending}
        onClick={() => toggle.mutate()}
      >
        <span className="switch-dot" />
      </button>
    </div>
  );
}
